import Vue from 'vue';
import CaptchaDialog from '@/components/captcha-dialog.vue';

// @ts-ignore
const DialogCtor = Vue.extend(CaptchaDialog);

type QueueItem = {
  resolve: () => void;
  reject: (reason: any) => void;
};

let pending = false;
let queue: QueueItem[] = [];

function processQueue(resolved: boolean) {
  pending = false;
  const q = queue;
  queue = [];
  for (const item of q) {
    if (resolved) {
      item.resolve();
    } else {
      item.reject(new Error('用户取消验证'));
    }
  }
}

function showCaptcha(captchaUrl: string): Promise<void> {
  if (pending) {
    return new Promise((resolve, reject) => {
      queue.push({ resolve, reject });
    });
  }

  pending = true;

  return new Promise((resolve, reject) => {
    const instance = new DialogCtor({
      propsData: { captchaUrl }
    });

    let resolved = false;

    function cleanup() {
      if (resolved) return;
      resolved = true;
      instance.$destroy();
      if (instance.$el && instance.$el.parentNode) {
        instance.$el.parentNode.removeChild(instance.$el);
      }
    }

    instance.$on('verified', () => {
      cleanup();
      resolve();
      processQueue(true);
    });

    instance.$on('cancel', () => {
      reject(new Error('用户取消验证'));
      processQueue(false);
    });

    instance.$on('hook:destroyed', () => {
      if (!resolved) {
        resolved = true;
        reject(new Error('用户取消验证'));
        processQueue(false);
      }
    });

    instance.$mount();
    document.body.appendChild(instance.$el);
  });
}

export { showCaptcha };
